var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 4.4H18.7V14.3H4.4V16.5C4.40085 16.7915 4.51701 17.0708 4.72312 17.2769C4.92923 17.483 5.20852 17.5992 5.5 17.6H17.6L22 22V5.5C21.9992 5.20852 21.883 4.92923 21.6769 4.72312C21.4708 4.51701 21.1915 4.40085 20.9 4.4ZM16.5 11V1.1C16.4992 0.808523 16.383 0.529227 16.1769 0.323121C15.9708 0.117015 15.6915 0.00084938 15.4 0H1.1C0.808523 0.00084938 0.529227 0.117015 0.323121 0.323121C0.117015 0.529227 0.00084938 0.808523 0 1.1V16.5L4.4 12.1H15.4C15.6915 12.0992 15.9708 11.983 16.1769 11.7769C16.383 11.5708 16.4992 11.2915 16.5 11Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsIcon);
export default __webpack_public_path__ + "static/media/chats_icon.2a87be6788dc263f512582fce8ad3449.svg";
export { ForwardRef as ReactComponent };